import styles from "./DetailsAside.module.scss";

export const detailsAsideCommandBarClassName = styles.commandBar;
